import { statusIconVals } from "../Helpers/DomHelper";
import { pingEndpoints } from "../Helpers/AjaxHelper";
import { displayStatusIcon } from "../Helpers/DomHelper";
import { endTest } from "../Helpers/EndpointHelper";
import { cancel, isLocal } from "../Helpers/ExecutionStatus";
const global = window;
const { selfHelp: { serverDependencies, resources } } = global;
const key = "serviceHealthEndpoints";
const selfHelpArmUri = "https://management.azure.com/healthcheck?api-version=2014-04-01";
const selfHelpAeoUri = "https://nam.comms.azure.net/";
const selfHelpAadUri = "https://login.microsoftonline.com/";
// Where the responses from the API requests are stored
let endpointResponses;
/** Ends tests. Updates DOM and Blob. Ensures that if tests have been cancelled execution stops. */
function finishTest() {
    if (cancel) {
        return;
    }
    endTest(key, endpointResponses);
}
/**
 * Determines which set of endpoints to use to ping (local vs portal) and calls helper function to get responses.
 */
function pingServerHealthEndpoints() {
    if (cancel) {
        return;
    }
    pingEndpoints(serverDependencies, false)
        .then((responses) => {
        endpointResponses = responses;
    })
        .then(() => finishTest())
        .catch((err) => {
        endpointResponses = err;
        finishTest();
    });
}
/**
 * Replaces uris for localhost for proper testing.
 * Values in Web.config used in other areas for the Portal do not reflect the uris expected for self help testing.
 */
function replaceUrisForLocalHost() {
    const armIndex = serverDependencies.findIndex((endpoint) => endpoint.name === resources.Endpoints_ARM);
    serverDependencies[armIndex] = { name: resources.Endpoints_ARM, uri: selfHelpArmUri };
    const emailIndex = serverDependencies.findIndex((endpoint) => endpoint.name === resources.Endpoints_AEO);
    serverDependencies[emailIndex] = { name: resources.Endpoints_AEO, uri: selfHelpAeoUri };
    const aadIndex = serverDependencies.findIndex((endpoint) => endpoint.name === resources.Endpoints_AAD);
    serverDependencies[aadIndex] = { name: resources.Endpoints_AAD, uri: selfHelpAadUri };
}
/** Triggers beginning of test and update of DOM. */
export function startTest() {
    if (isLocal) {
        replaceUrisForLocalHost();
    }
    displayStatusIcon(key, statusIconVals.inProgress);
    pingServerHealthEndpoints();
}
//# sourceMappingURL=ServiceHealthDiagnostics.js.map